import PageHeader from "@/components/PageHeader";
import AboutConan from "@/sections/AboutConan";
import About from "@/sections/About";
import Testimonials from "@/sections/Testimonials";
import PageCTA from "@/components/PageCTA";

const AboutPage = () => {
  return (
    <>
      <PageHeader
        tag="/ About Us"
        title="ABOUT"
        accent="US."
        subtitle="A trusted Edinburgh-based plumbing and drainage business with over 30 years on the tools — serving domestic and commercial customers across the Lothians."
      />
      <AboutConan />
      <About />
      <Testimonials />
      <PageCTA />
    </>
  );
};

export default AboutPage;
